import { styled } from 'styled-components';

import { colors, fontWeights, textStyles } from 'theme/theme';

export const StyledTable = styled.table`
  width: 100%;
  ${textStyles.bodySmall}

  thead th {
    text-align: left;
    color: ${colors.lightContentGrey};
    font-size: 14px;
    font-weight: ${fontWeights.semiBold};
  }

  th,
  td {
    padding: 8px;
  }

  tbody > tr:nth-of-type(odd) > * {
    background-color: ${colors.backgroundGrey};
  }
`;
